import { useSyncExternalStore } from 'react';
import type { Observable } from './store';

export function useObservable<T>(observable: Observable<T>): T {
  return useSyncExternalStore(observable.subscribe, observable.get, observable.get);
}

/**
 * Subscribes to one derived value of an observable; the component re-renders only when
 * that value changes (compared with Object.is). `select` must return a primitive or a
 * reference that is stable while unchanged.
 */
export function useObservableSelector<T, U>(observable: Observable<T>, select: (value: T) => U): U {
  const get = () => select(observable.get());
  return useSyncExternalStore(observable.subscribe, get, get);
}
